import { render, staticRenderFns } from "./InventoryBilling.vue?vue&type=template&id=2b7bef27&scoped=true&"
import script from "./InventoryBilling.vue?vue&type=script&lang=ts&"
export * from "./InventoryBilling.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryBilling.vue?vue&type=style&index=0&id=2b7bef27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7bef27",
  null
  
)

export default component.exports